import { BaseModel } from './base';

export class InventoryStatusDto extends BaseModel {
  id?: string;
  statusName: string;
  subscriberId: string;
  siteId: string;
}
